// 多人餐标识
import React from 'react';
import './index.css';

interface Props {
  data: any;
}

export default class GroupMealTag extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { data } = this.props;
    if (!data || !data.labelTextDTO) return null;
    const { labelTextDTO } = data;
    return (
      <view className="group-meal-tag" style={{ backgroundColor: labelTextDTO.bgColor || '#222222' }}>
        {labelTextDTO.icon && <image src={labelTextDTO.icon} className="group-meal-icon" />}
        {labelTextDTO.text
         && (
           <text
             className="group-meal-text" style={{ color: labelTextDTO.textcolor || '#FFFFFF' }}
             content={labelTextDTO.text}
           />
         )}
      </view>
    );
  }
}
